import * as React from "react";
const Equal = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 9H6v1h12V9Zm0 5H6v1h12v-1Z" }));
Equal.displayName = "Equal";
var Equal_default = Equal;
export {
  Equal_default as default
};
